/**
 * @file entangledWorldFallback.js
 * @description Provides a minimal entangled world release payload so the renderer
 *              and data manager can operate when live data is unavailable.
 */

const BASE_METADATA = {
  displayName: 'Fallback World',
  sciName: 'Planetaria Placeholder',
  description: 'Local fallback entangled world used when no release is available.',
  glow: { enabled: false },
  clouds: { enabled: false },
  step_one: {
    astronomical_body: {
      minimumCosmicLfo: 0.01,
      stellarLuminosityLsun: 1,
      frequencyCpd: 1,
      mass: 1,
    },
  },
};

const BASE_RELEASE = {
  version: 'fallback',
  snapshotAt: null,
  status: 'fallback',
  metadata: BASE_METADATA,
  assets: {},
  buildNotes: 'Generated by local fallback preset.',
  errorMessage: null,
};

export function createDefaultEntangledWorldFallback(options = {}) {
  const {
    worldId = 'fallback-world',
    version = BASE_RELEASE.version,
    metadata = {},
    availableVersions = [],
    snapshotAt = new Date().toISOString(),
  } = options;

  return {
    success: true,
    worldId,
    release: {
      ...BASE_RELEASE,
      version,
      snapshotAt,
      metadata: {
        ...BASE_METADATA,
        ...metadata,
        worldId,
        id: worldId,
      },
      assets: {
        ...BASE_RELEASE.assets,
      },
    },
    availableVersions: Array.isArray(availableVersions) ? availableVersions : [],
    isLatest: true,
  };
}

export const DEFAULT_ENTANGLED_WORLD_FALLBACK = createDefaultEntangledWorldFallback();
